import {createSelector} from 'reselect';
import props from '../../props';

export default createSelector(
    props.modals_action.data.affiliate_signup,
    props.games.games,
    props.user.user,
    (data, games, user) => {
        const game = games ? games.filter(game => game.slug === data.choose.game || user?.game)[0] || false : false;

        return {
            stage: data.stage,
            game,
            user
        }
    }
)